// src/services/branding_service.js
import { get_token } from '@/router/index.js';
import $ from 'jquery'; // jQuery

class branding_service {
  constructor() {
    this.colors = null;
    this.logos = null;
    this.initialized = false;
  }

  async load_branding(org_id) {
    if (!org_id) {
      console.warn('No organization ID provided');
      return null;
    }

    const token = get_token();
    if (!token) {
      console.warn('No auth token available');
      return null;
    }

    try {
      // Load colors and logos in parallel
      const [colors_res, logos_res] = await Promise.all([
        fetch(`${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_organization_colors/${org_id}/`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          }
        }),
        fetch(`${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_organization_logos/${org_id}/`, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          }
        })
      ]);

      if (colors_res.ok) {
        const colors_data = await colors_res.json();
        this.colors = colors_data.data || {};
      }

      if (logos_res.ok) {
        const logos_data = await logos_res.json();
        this.logos = logos_data.data || {};
      }

      this.apply_branding();
      this.initialized = true;

      return {
        colors: this.colors,
        logos: this.logos
      };
    } catch (error) {
      console.error('Failed to load branding:', error);
      return null;
    }
  }

  apply_branding() {
    const root = document.documentElement;

    // Apply colors
    if (this.colors?.primary_color) {
      root.style.setProperty('--primary-color', this.colors.primary_color);
      root.style.setProperty('--deep-red-color', this.colors.primary_color);
      root.style.setProperty('--red-gradient-start', this.colors.primary_color);
      root.style.setProperty('--red-light-color', this.colors.primary_color)
    }

    if (this.colors?.secondary_color) {
      root.style.setProperty('--secondary-color', this.colors.secondary_color);
      root.style.setProperty('--red-gradient-end', this.colors.secondary_color);
    }

    if (this.colors?.accent) {
      root.style.setProperty('--accent-color', this.colors.accent);
      root.style.setProperty('--red-dark-color', this.colors.accent);
    }

    // Apply logos using jQuery
    if (this.logos) {
      if (this.logos.logo) {
        $('.main-logo, .navbar-logo').attr('src', this.logos.logo);
      }

      if (this.logos.favicon) {
        this.update_favicon(this.logos.favicon);
      }
    }
  }

  update_favicon(favicon_url) {
    // Remove existing favicons
    $("link[rel*='icon']").remove();

    // Add new favicon - SECURE: Create elements without HTML parsing
    const favicon_link = document.createElement('link');
    favicon_link.rel = 'icon';
    favicon_link.type = this.get_favicon_type(favicon_url);
    favicon_link.href = favicon_url;
    $('head').append(favicon_link);

    // Add apple-touch-icon - SECURE: Create elements without HTML parsing
    const apple_touch_icon = document.createElement('link');
    apple_touch_icon.rel = 'apple-touch-icon';
    apple_touch_icon.href = favicon_url;
    $('head').append(apple_touch_icon);
  }

  get_favicon_type(favicon_url) {
    const normalized_url = String(favicon_url || '').toLowerCase();

    if (normalized_url.includes('.png')) return 'image/png';
    if (normalized_url.includes('.svg')) return 'image/svg+xml';
    if (normalized_url.includes('.gif')) return 'image/gif';
    if (normalized_url.includes('.jpg') || normalized_url.includes('.jpeg')) return 'image/jpeg';

    return 'image/x-icon';
  }

  get_branding = () => ({
    colors: this.colors,
    logos: this.logos,
    initialized: this.initialized
  });


  clear_branding() {
    this.colors = null;
    this.logos = null;
    this.initialized = false;

    const root = document.documentElement;
    root.style.removeProperty('--primary-color');
    root.style.removeProperty('--secondary-color');
    root.style.removeProperty('--accent-color');
    root.style.removeProperty('--deep-red-color');
    root.style.removeProperty('--red-dark-color');
  }
}

// Export singleton instance
export default new branding_service();
